import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GATHERINGS = [
  { key: "waterfall", name: "Waterfall Medicine: Field Trip", sub: "October 30th, 2026 · Tentative", start: new Date(2026, 9, 30), end: new Date(2026, 9, 31), img: "/img/waterfall.jpg" },
  { key: "light", name: "The Light Ceremony", sub: "November 22nd – 27th", start: new Date(2026, 10, 22), end: new Date(2026, 10, 28), img: "/img/lights.jpg" },
];

const Unit = ({ value, label }) => (
  <div className="text-center">
    <p className="font-serif-h text-4xl sm:text-5xl text-white leading-none">{String(value).padStart(2, "0")}</p>
    <p className="text-[10px] uppercase tracking-[0.25em] text-white/70 mt-2">{label}</p>
  </div>
);

const Card = ({ g, now }) => {
  const ms = g.start - now;
  const live = ms <= 0 && now < g.end;
  const past = now >= g.end;
  const d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, m = Math.floor(ms / 60000) % 60;
  return (
    <Link to={`/members/rsvp/${g.key}`} data-testid={`countdown-${g.key}`} className="group relative block rounded-3xl overflow-hidden min-h-[15rem]">
      <img src={g.img} alt={g.name} className="absolute inset-0 h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#232b1b]/95 via-[#232b1b]/80 to-[#232b1b]/60" />
      <div className="relative p-7 flex flex-col h-full justify-between gap-6">
        <div>
          <p className="font-serif-h text-3xl text-white">{g.name}</p>
          <p className="text-xs text-[#b1cc90] tracking-wide mt-1">{g.sub}</p>
        </div>
        {live && <p data-testid={`countdown-live-${g.key}`} className="font-serif-h italic text-2xl text-white">The circle is gathered now. Come into the light.</p>}
        {past && <p className="font-serif-h italic text-2xl text-white/85">This gathering has passed. We carry its blessings with us.</p>}
        {!live && !past && (
          <div className="flex gap-6" data-testid={`countdown-timer-${g.key}`}>
            <Unit value={d} label="days" /><Unit value={h} label="hours" /><Unit value={m} label="minutes" />
          </div>
        )}
        {!past && <p className="text-xs text-white/80">{live ? "" : "until we gather · "}tap to hold your place</p>}
      </div>
    </Link>
  );
};

export const CeremonyCountdown = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <section data-testid="ceremony-countdown" className="mt-12">
      <p className="eyebrow">The days until we gather</p>
      <div className="grid md:grid-cols-2 gap-6 mt-5">
        {GATHERINGS.map((g) => <Card key={g.key} g={g} now={now} />)}
      </div>
    </section>
  );
};
